import { alpha, Stack, Box, IconButton, Button, Tabs, Tab } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import useBundleTranslation from 'i18n';
import { formAPI } from 'api/form';
import { useAppBuilderContext } from 'app/app/editor/context';
import ElementsTab from 'app/app/editor/tabs/elements/ElementsTab';
import ComponentsTab from 'app/app/editor/tabs/components/ComponentsTab';
import { Resizable } from 're-resizable';
import { useEffect, useState } from 'react';
import StateTab from 'app/app/editor/tabs/state/StateTab';
import HistoryTab from 'app/app/editor/tabs/history/HistoryTab';
// import { ReactComponent as DevicesIco } from './icons/devices.svg';
// import ReactSelect from 'components/common/react-select/ReactSelect';
// import RecoverHistory from 'app/app/editor/parts/RecoverHistory';

interface AppBuilderRightPanelProps {
    rightPanelState: string;
    setRightPanelState: (value: string) => void;
    componentUid: string | null;
    internalName: string;
    activeTab: string;
    setActiveTab: (value: string) => void;
}

const RIGHT_PANEL_DEFAULT_WIDTH = 384;

export default function AppBuilderRightPanel(props: AppBuilderRightPanelProps) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
    const [panelWidth, setPanelWidth] = useState<number>(RIGHT_PANEL_DEFAULT_WIDTH);
    const [showDevicesPanel, setShowDevicesPanel] = useState<boolean>(false);
    const [showSiteGrid, setShowSiteGrid] = useState<boolean>(true);
    const [selectedDevice, setSelectedDevice] = useState<string>('1');
    const {
        internalName,
        componentUid,
        rightPanelState,
        setRightPanelState = () => {},
        activeTab,
        setActiveTab = () => {},
    } = props;

    const tabs = ctx.withTemplate ? ['elements'] : ['elements', 'components', 'state', 'history'];

    let onSaveButton = () => {
        formAPI.save('/data/app/page/' + internalName + '/save', { page: ctx.page });
    };

    useEffect(() => {
        ctx.sendMessage({ name: 'toggleRightMenu', data: { open: isCollapsed, width: panelWidth } });
    }, [panelWidth, isCollapsed]);

    const isHistorySelected = ctx.history.selectedHistoryRecord > 0;
    const inIframe = (() => {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    })();

    // useEffect(() => {
    //     const mainContainer = document.getElementById('mi-app');
    //     if (mainContainer)
    //         mainContainer.classList.toggle('devices-panel--active', showDevicesPanel || isHistorySelected);
    // }, [showDevicesPanel, isHistorySelected]);

    useEffect(() => {
        const mainContainer = document.getElementById('mi-app');
        if (mainContainer) mainContainer.classList.toggle('hide-layout-grid', !showSiteGrid);
    }, [showSiteGrid]);

    return (
        <>
            {/*{(showDevicesPanel || isHistorySelected) && (*/}
            {/*    <Stack*/}
            {/*        direction={'row'}*/}
            {/*        className={'app-builder__devices-panel'}*/}
            {/*        sx={{*/}
            {/*            backgroundColor: 'background.default',*/}
            {/*            position: 'fixed',*/}
            {/*            top: inIframe ? 0 : '40px',*/}
            {/*            right: 0,*/}
            {/*            left: 0,*/}
            {/*            justifyContent: 'center',*/}
            {/*            py: 0.5,*/}
            {/*            pr: panelWidth + 'px',*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        {isHistorySelected && <RecoverHistory />}*/}
            {/*        {showDevicesPanel && !isHistorySelected && (*/}
            {/*            <Box sx={{ width: '200px' }}>*/}
            {/*                Select Device:*/}
            {/*                <ReactSelect*/}
            {/*                    data={*/}
            {/*                        [*/}
            {/*                            {*/}
            {/*                                value: '1',*/}
            {/*                                label: 'Iphone XR',*/}
            {/*                            },*/}
            {/*                            {*/}
            {/*                                value: '2',*/}
            {/*                                label: 'Iphone 16 Pro Max',*/}
            {/*                            },*/}
            {/*                            {*/}
            {/*                                value: '3',*/}
            {/*                                label: 'Pixel 8 Pro',*/}
            {/*                            },*/}
            {/*                            {*/}
            {/*                                value: '4',*/}
            {/*                                label: 'Ipad Air',*/}
            {/*                            },*/}
            {/*                            {*/}
            {/*                                value: '5',*/}
            {/*                                label: 'Samsung Galaxy',*/}
            {/*                            },*/}
            {/*                        ] as any*/}
            {/*                    }*/}
            {/*                    value={selectedDevice}*/}
            {/*                    update={(newValue) => {*/}
            {/*                        setSelectedDevice(newValue);*/}
            {/*                    }}*/}
            {/*                />*/}
            {/*            </Box>*/}
            {/*        )}*/}
            {/*    </Stack>*/}
            {/*)}*/}
            <Box
                className={`app-builder__right-panel ${isCollapsed ? 'app-builder__right-panel--collapsed' : ''}`}
                sx={{
                    backgroundColor: 'background.default',
                    position: 'fixed',
                    top: inIframe ? 0 : '40px',
                    right: 0,
                    bottom: 0,
                    boxShadow: (theme) => `0px 16px 32px 0px ${alpha(theme.palette.text.primary, 0.08)}`,
                    zIndex: 2,
                    '&.app-builder__right-panel--collapsed .app-builder__right-panel-container': {
                        display: 'none !important',
                    },
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        right: '100%',
                        top: '50%',
                        backgroundColor: 'background.default',
                        borderTopLeftRadius: '4px',
                        borderBottomLeftRadius: '4px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        py: 1,
                        px: 0.5,
                        zIndex: 2,
                        transform: 'translateY(-50%)',
                        '&:hover': {
                            color: 'primary.main',
                            cursor: 'pointer',
                        },
                    }}
                    onClick={() => {
                        setIsCollapsed(!isCollapsed);
                    }}
                >
                    <IconMi icon={isCollapsed ? 'chevrons-left' : 'chevrons-right'} sx={{ fontSize: '14px' }} />
                </Box>
                <Resizable
                    defaultSize={{
                        width: RIGHT_PANEL_DEFAULT_WIDTH,
                        height: '100%',
                    }}
                    className={'app-builder__right-panel-container'}
                    minWidth={260}
                    maxWidth={432}
                    onResize={(event: MouseEvent | TouchEvent, direction: any, elementRef: HTMLElement, delta: any) => {
                        setPanelWidth(elementRef.getBoundingClientRect().width);
                    }}
                    onResizeStart={(event, direction, elementRef) => {
                        elementRef.classList.add('resizing-active');
                    }}
                    onResizeStop={(event, direction, elementRef, delta) => {
                        elementRef.classList.remove('resizing-active');
                    }}
                    handleComponent={{
                        left: (
                            <Stack
                                sx={{
                                    position: 'relative',
                                    overflow: 'hidden',
                                    height: '100%',
                                    width: '100%',
                                    flexShrink: 0,
                                    borderRight: '1px solid',
                                    borderColor: 'transparent',
                                    transition: 'all 0s ease-in-out .1s',
                                    '&:hover, .resizing-active &': {
                                        borderColor: (theme) => theme.palette.primary.main,
                                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                                    },
                                }}
                            />
                        ),
                    }}
                    handleStyles={{
                        left: {
                            left: '-5px',
                            height: '100%',
                            width: '5px',
                            zIndex: 1,
                        },
                    }}
                    enable={{
                        top: false,
                        right: false,
                        bottom: false,
                        left: true,
                        topRight: false,
                        bottomRight: false,
                        bottomLeft: false,
                        topLeft: false,
                    }}
                >
                    <Stack height={1}>
                        {!inIframe && (
                            <Box
                                sx={{
                                    flexShrink: 0,
                                    px: 2,
                                    py: 1,
                                    borderBottom: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
                                }}
                            >
                                <Button
                                    variant={'contained'}
                                    color={'success'}
                                    startIcon={<IconMi icon="save" />}
                                    onClick={onSaveButton}
                                >
                                    {t('save_btn')}
                                </Button>
                            </Box>
                        )}
                        <Stack
                            direction={'row'}
                            sx={{
                                flexShrink: 0,
                                alignItems: 'center',
                                borderBottom: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
                                '.MuiTabs-root': { minHeight: 0, mb: '-1px' },
                                '.MuiTab-root': {
                                    padding: '5px 12px',
                                    minHeight: '28px',
                                },
                            }}
                            flexShrink={0}
                        >
                            <Stack
                                onClick={() => {
                                    setShowSiteGrid(!showSiteGrid);
                                }}
                                direction={'row'}
                                sx={{
                                    width: '24px',
                                    height: '24px',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: (theme) =>
                                        showSiteGrid ? 'primary.main' : alpha(theme.palette.text.primary, 0.4),
                                    '&:hover': {
                                        opacity: 0.65,
                                        cursor: 'pointer',
                                    },
                                }}
                            >
                                <IconMi icon={'layout'} sx={{ fontSize: '16px' }} />
                            </Stack>
                            {/*{!ctx.withTemplate && (*/}
                            {/*    <Stack*/}
                            {/*        onClick={() => {*/}
                            {/*            setShowDevicesPanel(!showDevicesPanel);*/}
                            {/*        }}*/}
                            {/*        direction={'row'}*/}
                            {/*        sx={{*/}
                            {/*            width: '24px',*/}
                            {/*            height: '24px',*/}
                            {/*            alignItems: 'center',*/}
                            {/*            justifyContent: 'center',*/}
                            {/*            svg: { width: '20px', height: '20px', fill: 'currentColor' },*/}
                            {/*            color: (theme) =>*/}
                            {/*                showDevicesPanel ? 'primary.main' : alpha(theme.palette.text.primary, 0.6),*/}
                            {/*            '&:hover': {*/}
                            {/*                opacity: 0.65,*/}
                            {/*                cursor: 'pointer',*/}
                            {/*            },*/}
                            {/*        }}*/}
                            {/*    >*/}
                            {/*        <DevicesIco />*/}
                            {/*    </Stack>*/}
                            {/*)}*/}
                            <Tabs
                                value={activeTab}
                                onChange={(event: React.SyntheticEvent, newValue: string) => {
                                    setActiveTab(newValue);
                                }}
                            >
                                {tabs.map((tab) => (
                                    <Tab label={t(`main_tabs.${tab}`)} key={tab} value={tab} />
                                ))}
                            </Tabs>
                        </Stack>
                        <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                            {'elements' === activeTab && (
                                <ElementsTab panelWidth={panelWidth} componentUid={componentUid} />
                            )}
                            {'components' === activeTab && <ComponentsTab />}
                            {'state' === activeTab && <StateTab />}
                            {'history' === activeTab && <HistoryTab />}
                        </Box>
                    </Stack>
                </Resizable>
            </Box>
        </>
    );
}
